import { z } from 'zod'

/** Les deux onglets de l'écran « Équipes », dans l'ordre du prototype. */
export const TEAMS_TABS = ['teams', 'members'] as const

export type TeamsTab = (typeof TEAMS_TABS)[number]

/**
 * L'onglet actif de « Équipes », **dans l'URL**.
 *
 * ⚠️ **Ajouté pour la fiche membre (#129), et il lui est nécessaire.** Sa première action est
 * « ← Tous les membres » : sans cet état, le retour atterrirait sur l'onglet `Équipes`, et
 * l'action mentirait sur sa destination. Un onglet qu'une action désigne n'est plus un état local.
 *
 * ⚠️ **Même tolérance que les filtres du « Tableau des demandes »** (M21) : un `?tab=agents` venu
 * d'un signet écrit avant un renommage retombe sur `teams` plutôt que de vider l'écran. Le
 * `.catch()` vit ici, à la frontière, et non dans un schéma de domaine — l'onglet n'est pas une
 * donnée métier.
 */
export const teamsSearchSchema = z.object({
  tab: z.enum(TEAMS_TABS).default('teams').catch('teams'),
})

export type TeamsSearch = z.infer<typeof teamsSearchSchema>

/**
 * Les valeurs par défaut du schéma. Elles servent au `stripSearchParams` de la route : `/teams`
 * reste `/teams` tant qu'on n'a pas changé d'onglet, et une adresse copiée ne porte que ce qui a
 * été choisi.
 */
export const TEAMS_DEFAULTS: TeamsSearch = teamsSearchSchema.parse({})
